import _ from 'underscore';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import instrumentSetting from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import instrumentationSvc from '@bingads-webui-static-legacy/instrumentation/index';
import instrumentConsts from '@bingads-webui-static-legacy/instrumentation/constants';
import pageContext from '@bingads-webui-static-legacy/page-context';
import scopeService from '@bingads-webui-static-legacy/scope-service';
import { BulkAssociationSectionView } from '@bingads-webui-campaign-legacy/audience-bulk-edit-common-association/view/bulk-association-section';
import BulkEditAssociationViewModel from '@bingads-webui-campaign-legacy/audience-bulk-edit-common-association/viewmodel/association';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/audience/association');

export default class View extends BaseView {
  initialize(options) {
    if (options.perfMarker) {
      this.perfMarker = options.perfMarker;
    }

    this.scope = scopeService.getScope();
    this.grid = options.grid;
    this.entityLevel = options.entityLevel;
    super.initialize(options);
    this.ko_model = new BulkEditAssociationViewModel(); /* eslint camelcase:0 */
    this.IsAIMCampaignEnabled = pageContext.Permissions.IsAIMCampaignEnabled;
    this.isNewAudienceEnabled = pageContext.Permissions.IsNewAudienceEnabled;
    this.doubleListBoxView = new BulkAssociationSectionView({
      scope: this.scope,
      entityLevel: this.entityLevel,
      isForVNext: options.isForVNext,
      router: options.router,
      currentCampaign: options.currentCampaign,
      newI18n: options.newI18n,
    });
    this.doubleListBoxView.on('cleanup', () => {
      this.cancelJob();
    });

    this.template = options.template;
    this.onSuccessCallback = options.onSuccessCallback;
    this.validate = options.validate;
    this.formatAssociation = options.formatAssociation;
  }

  remove() {
    this.doubleListBoxView.remove();
    super.remove();
  }

  render() {
    if (this.perfMarker) {
      this.perfMarker.willRender();
    }
    let func = () => {

      super.render();

      this.$el.find('.panel-heading.bulkAssociation').after(this.doubleListBoxView.render().el);

      this.$el.find('.doubleListBoxContainer').show();
      this.$el.find('.save-btn').removeAttr('disabled');

      // Validates the selection and show an error message if there's an issue
      // skipping the check for maximum number of associations since lists are not yet selectedp
      this.validateSelection(null);

      return this;
    };

    if (instrumentationSvc.asLoggingStart) {
      return instrumentationSvc.asLoggingStart(func,
        this.isNewAudienceEnabled ? instrumentSetting.ACTIVITYNAME.LoadBulkEditTargetingExclusionByDmp : instrumentSetting.ACTIVITYNAME.LoadBulkEditTargetingExclusion,
        this.isNewAudienceEnabled ? instrumentSetting.SCENARIONAME.BulkEditTargetingExclusionByDmp : instrumentSetting.SCENARIONAME.BulkEditTargetingExclusion)();
    } else {
      return func();
    }
  }

  validateSelection(selectedListsCount) {
    if (_.isFunction(this.validate)) {
      return this.validate(selectedListsCount);
    }

    return false;
  }

  // click cancel
  cancelJob() {
    if (instrumentationSvc.logMessage) {
      if (this.DmpEnabled) {
        instrumentationSvc.logMessage(
          [instrumentConsts.LOGCATEGORY.TRACE],
          instrumentConsts.LOGLEVEL.INFO,
          'SaveBulkEditTargetingExclusionByDmp/Cancel',
          '');
      } else {
        instrumentationSvc.logMessage(
          [instrumentConsts.LOGCATEGORY.TRACE],
          instrumentConsts.LOGLEVEL.INFO,
          'SaveBulkEditTargetingExclusion/Cancel',
          '');
      }
    }

    super.cancelJob();
  }

  onJobSuccess() {
    super.onJobSuccess();
    this.jobSucceeded = true;
  }

  submitJob() {
    let { associationList, exclusionList } = this.doubleListBoxView.getLists();

    if (!this.doubleListBoxView.validateBidPercentage()) {
      return;
    }

    if (!this.doubleListBoxView.validateCustomRestriction()) {
      return;
    }

    if (!this.doubleListBoxView.validateCashbackPercent()) {
      return;
    }

    //Validation

    // Getting number of lists selected for calculating the association max limit.
    let selectedListsCount = associationList.length + exclusionList.length;

    // Validates the selection again on job submitting, and update the error message if there's an issue
    // We should proceed with submitting the job when the selection of Ad Groups is not all Content-only
    // Otherwise, i.e. we should block the job when the selection of Ad Groups is all Content-only
    if (this.validateSelection(selectedListsCount)) {
      // clean all non-critical error and let it go
      this.doubleListBoxView.clearAllErrors();

      super.submitJob();
    }
  }

  hideView() {
    super.hideView();
    if (this.jobSucceeded) {
      // Show association success information message
      this.onSuccessCallback();
    }
  }

  setAction() {
    let func = () => {
      const action = this.doubleListBoxView.getAction();

      this.model.set('BatchAction', action);
    };

    if (instrumentationSvc.asLoggingStart) {
      return instrumentationSvc.asLoggingStart(func,
        this.isNewAudienceEnabled ? instrumentSetting.ACTIVITYNAME.SaveBulkEditTargetingExclusionByDmp : instrumentSetting.ACTIVITYNAME.SaveBulkEditTargetingExclusion,
        this.isNewAudienceEnabled ? instrumentSetting.SCENARIONAME.BulkEditTargetingExclusionByDmp : instrumentSetting.SCENARIONAME.BulkEditTargetingExclusion)();
    } else {
      return func();
    }
  }

  getIdFilter() {
    return filterHelper.getAdGroupIdFilterExcludingContentOnly(this.grid);
  }

  getProgressText() {
    return i18n.get('BulkEdit_AudienceAssociation_ProgressText');
  }

  _formatAssociation(rows) {
    return this.formatAssociation(rows);
  }

  formatPreviewResults(results) {
    return this._formatAssociation(results);
  }

  formatErrors(errors) {
    return this._formatAssociation(errors);
  }
}
